<template>
<div>
	<span v-html="$t('password.restrictions')"></span>
	<input type="password" class="form-control inputElement" v-bind:placeholder="$t('login.password')" autocomplete="off">
	<input type="password" class="form-control" id="password2" v-bind:placeholder="$t('login.passwordRepeat')" autocomplete="off">

</div>
</template>

<script>
export default {
  name: "TextInput",
  data() {
    return {
      output: {}
    };
  },
  props: ["value", "id"]
};
</script>

<style scoped>
.inputElement {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/input/PasswordInput.vue